'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Embedded Tweets',

    defaultProps: function defaultProps() {
        return {
            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
        };
    },
    componentDidMount: function componentDidMount() {
        var node = _reactDom2['default'].findDOMNode(this);
        var twitterScript = document.createElement('script');
        twitterScript.src = '//platform.twitter.com/widgets.js';
        twitterScript.charset = 'utf-8';
        twitterScript.async = true;
        node.appendChild(twitterScript);
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            _react2['default'].createElement(
                'div',
                { className: 'small-12 small-centered small-text-center columns' },
                _react2['default'].createElement(
                    'h6',
                    { className: 'm-marketing-page--subheader-small c-ashen', style: { fontSize: 18 } },
                    this.props.embeddedTweetsHeaderText
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'small-12 text-center m-marketing-page--embedded-tweets' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-marketing-page--embedded-tweet' },
                    _react2['default'].createElement(
                        'blockquote',
                        { className: 'twitter-tweet', lang: 'en' },
                        _react2['default'].createElement(
                            'p',
                            { lang: 'en', dir: 'ltr' },
                            'A few of my favorite things that have up leveled my business into the modern age.',
                            _react2['default'].createElement(
                                'a',
                                { href: 'https://twitter.com/AcuitySchedulin' },
                                '@AcuitySchedulin'
                            ),
                            ',',
                            _react2['default'].createElement(
                                'a',
                                { href: 'https://twitter.com/freshbooks' },
                                '@freshbooks'
                            ),
                            ',',
                            _react2['default'].createElement(
                                'a',
                                { href: 'https://twitter.com/HelloSign' },
                                '@HelloSign'
                            ),
                            ',',
                            _react2['default'].createElement(
                                'a',
                                { href: 'https://twitter.com/BraidCreative' },
                                '@BraidCreative'
                            )
                        ),
                        '\u2014 Jolene Park (@JolenePark)',
                        _react2['default'].createElement(
                            'a',
                            { href: 'https://twitter.com/JolenePark/status/644242654952210432' },
                            'September 16, 2015'
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-marketing-page--embedded-tweet' },
                    _react2['default'].createElement(
                        'blockquote',
                        { className: 'twitter-tweet', lang: 'en' },
                        _react2['default'].createElement(
                            'p',
                            { lang: 'en', dir: 'ltr' },
                            _react2['default'].createElement(
                                'a',
                                { href: 'https://twitter.com/HelloSign' },
                                '@HelloSign'
                            ),
                            'has finally helped me get my contract game on track! Now I\'ve got your signature.',
                            _react2['default'].createElement(
                                'a',
                                { href: 'http://t.co/EewBKaXZCX' },
                                'http://t.co/EewBKaXZCX'
                            ),
                            _react2['default'].createElement(
                                'a',
                                { href: 'https://twitter.com/hashtag/business?src=hash' },
                                '#business'
                            )
                        ),
                        '\u2014 Melissa Carter (@wcornercreative)',
                        _react2['default'].createElement(
                            'a',
                            { href: 'https://twitter.com/wcornercreative/status/638107795896844290' },
                            'August 30, 2015'
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-marketing-page--embedded-tweet' },
                    _react2['default'].createElement(
                        'blockquote',
                        { className: 'twitter-tweet', lang: 'en' },
                        _react2['default'].createElement(
                            'p',
                            { lang: 'en', dir: 'ltr' },
                            _react2['default'].createElement(
                                'a',
                                { href: 'https://twitter.com/HelloSign' },
                                '@HelloSign'
                            ),
                            ' You\'re brilliant.'
                        ),
                        '\u2014 Gloria Steinberg (@iprookie)',
                        _react2['default'].createElement(
                            'a',
                            { href: 'https://twitter.com/iprookie/status/641273263092572160' },
                            'September 8, 2015'
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-marketing-page--embedded-tweet' },
                    _react2['default'].createElement(
                        'blockquote',
                        { className: 'twitter-tweet', lang: 'en' },
                        _react2['default'].createElement(
                            'p',
                            { lang: 'en', dir: 'ltr' },
                            'Fast, Secure, and Legally Binding eSignatures for Business',
                            _react2['default'].createElement(
                                'a',
                                { href: 'https://t.co/yZG4FoIFkR' },
                                'https://t.co/yZG4FoIFkR'
                            )
                        ),
                        '\u2014 John Wojewoda (@D_digital_dog)',
                        _react2['default'].createElement(
                            'a',
                            { href: 'https://twitter.com/D_digital_dog/status/637269988160749568' },
                            'August 28, 2015'
                        )
                    )
                )
            )
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/embedded-tweets.jsx
 ** module id = 1215
 ** module chunks = 0
 **/